"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = reducer;
exports.getRlmId = exports.getDeviceDataByType = exports.getDevice = exports.getContractSpecificItems = void 0;
exports.loadCurrent = loadCurrent;
exports.loadDeviceData = loadDeviceData;
exports.setDeviceDate = setDeviceDate;
exports.setMeasurementTimeList = setMeasurementTimeList;
exports.setSelectedDevice = setSelectedDevice;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _moment = _interopRequireDefault(require("moment"));
var _rlmDeviceApi = require("../api/rlmDeviceApi");
var _SessionHandler = _interopRequireDefault(require("../utils/SessionHandler"));
var _Router = _interopRequireDefault(require("../../utils/Router"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// Actions
var LOAD_CURRENT_DEVICES = 'api/reducer/RLM/GET_DEVICES';
var SET_SELECTED_DEVICE = 'api/reducer/RLM/DEVICE';
var LOAD_CURRENT_DEVICE_DATA = 'api/reducer/RLM/GET_DEVICE_DATA';
var LOAD_CURRENT_DEVICE_DATA_STARTED = 'api/reducer/RLM/LOAD_CURRENT_DEVICE_DATA_STARTED';
var LOAD_CURRENT_DEVICE_DATA_FAILURE = 'api/reducer/RLM/LOAD_CURRENT_DEVICE_DATA_FAILURE';
var SET_DEVICE_DATE = 'api/reducer/RLM/DEVICE_DATE';
var SET_START_TIME = 'api/reducer/RLM/START_TIME';
var getRlmId = exports.getRlmId = function getRlmId(device) {
  return "".concat(device.locationId).concat(device.profileRole).concat(device.profileDeterminant);
};
var getDevice = exports.getDevice = function getDevice(devices, rlmId) {
  return devices ? devices.find(function (elem) {
    return getRlmId(elem) === rlmId;
  }) : null;
};
/**
 * returns type and contract specific values
 * @param measurementData {array} - data from the response
 * @param dataFilter {string} - what data type you're interested in
 * @returns {*}
 */
var getDeviceDataByType = exports.getDeviceDataByType = function getDeviceDataByType(measurementData, type) {
  return measurementData.filter(function (x) {
    return x.type === type;
  });
};
/**
 * creates contractspecific value series to display in the graph
 * @param deviceData {array} - array of available data per contract account
 * @returns {*[]}
 */

var getContractSpecificItems = exports.getContractSpecificItems = function getContractSpecificItems(deviceData, type) {
  return Array.from(deviceData.map(function (elem) {
    return {
      contractAccountId: type === 'rlm' && elem.contractAccountId,
      time: (0, _moment.default)(elem.startTime * 1000),
      standardTime: type === 'smartmeter' && (0, _moment.default)(elem.startTime * 1000),
      values: type === 'rlm' ? elem.values : elem.measurements,
      standardMeasurements: elem.standardMeasurements && elem.standardMeasurements
    };
  }));
};

// Reducer
function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  var getPreselectedDevice = function getPreselectedDevice(devices) {
    var id = _Router.default.getParameter('rlmId');
    if (id) {
      return id;
    }
    if (devices[0]) {
      _Router.default.setParameter({
        rlmId: getRlmId(devices[0])
      });
      return getRlmId(devices[0]);
    }
    return null;
  };
  switch (action.type) {
    case LOAD_CURRENT_DEVICES:
      return _objectSpread(_objectSpread({}, state), {}, {
        devicesList: action.data.innerData,
        rlmId: getPreselectedDevice(action.data.innerData)
      });
    case SET_SELECTED_DEVICE:
      _Router.default.setParameter({
        rlmId: action.data.rlmId
      });
      return _objectSpread(_objectSpread({}, state), {}, {
        rlmId: action.data.rlmId
      });
    case LOAD_CURRENT_DEVICE_DATA:
      return _objectSpread(_objectSpread({}, state), {}, {
        deviceData: getDeviceDataByType(action.data.innerData.measurements, 'METERED')
      });
    case SET_DEVICE_DATE:
      return _objectSpread(_objectSpread({}, state), {}, {
        selectedStartDate: action.data.dateFrom,
        selectedEndDate: action.data.dateTo
      });
    case SET_START_TIME:
      return _objectSpread(_objectSpread({}, state), {}, {
        measurementData: {
          interval: state.deviceData[0].intervalSec * 1000,
          unit: state.deviceData[0].unit,
          contractSpecificValues: getContractSpecificItems(state.deviceData, 'rlm')
        },
        deviceDataProcceding: false,
        apiErrorCode: null
      });
    case LOAD_CURRENT_DEVICE_DATA_FAILURE:
      return _objectSpread(_objectSpread({}, state), {}, {
        deviceDataProcceding: false,
        apiErrorCode: action.data.error
      });
    case LOAD_CURRENT_DEVICE_DATA_STARTED:
      return _objectSpread(_objectSpread({}, state), {}, {
        deviceDataProcceding: true
      });
    default:
      return state;
  }
}

// Action Creators
function loadCurrent(dispatch) {
  var resp = (0, _rlmDeviceApi.getDevices)();
  return resp.then(function (reponse) {
    dispatch({
      type: LOAD_CURRENT_DEVICES,
      data: {
        innerData: reponse.data.content
      }
    });
  });
}
function setSelectedDevice(dispatch, rlmId) {
  _SessionHandler.default.resetPermissions();
  dispatch({
    type: SET_SELECTED_DEVICE,
    data: {
      rlmId: rlmId
    }
  });
}
function loadDeviceData(dispatch, location, dateFrom, dateTo) {
  var resp = (0, _rlmDeviceApi.getDeviceData)(location, dateFrom, dateTo);
  dispatch({
    type: LOAD_CURRENT_DEVICE_DATA_STARTED
  });
  return resp.then(function (response) {
    dispatch({
      type: LOAD_CURRENT_DEVICE_DATA,
      data: {
        innerData: response.data
      }
    });
  }).catch(function (err) {
    var _err$response, _err$response$data, _err$response$data$er;
    var errorCode = 'dataNotFound';
    if ((_err$response = err.response) === null || _err$response === void 0 ? void 0 : (_err$response$data = _err$response.data) === null || _err$response$data === void 0 ? void 0 : (_err$response$data$er = _err$response$data.errors) === null || _err$response$data$er === void 0 ? void 0 : _err$response$data$er[0]) {
      errorCode = err.response.data.errors[0].code.split('.').pop();
    }
    dispatch({
      type: LOAD_CURRENT_DEVICE_DATA_FAILURE,
      data: {
        error: errorCode
      }
    });
  });
}
function setDeviceDate(dispatch, dateFrom, dateTo) {
  dispatch({
    type: SET_DEVICE_DATE,
    data: {
      dateTo: dateTo,
      dateFrom: dateFrom
    }
  });
}
function setMeasurementTimeList(dispatch, time) {
  dispatch({
    type: SET_START_TIME,
    data: {
      time: time
    }
  });
}